
<div class="toggle-wrapper">
    <div class="filter-by-button" [class.toggled-on]="value" [class.toggled-off]="!value">
        <span class="slider-indicator"></span>
        <button class="btns" [class.btn-active]="value" title="Enabled" (click)="value = true; onChange(true); onTouched()">Enabled</button>
        <button class="btns" [class.btn-active]="!value" title="Disabled" (click)="value = false; onChange(false); onTouched()">Disabled</button>
    </div>  
    <label class="toggle-label" *ngIf="field.label">
        {{ field.label }} <span class="required" *ngIf="field.required"> *</span>
    </label>
</div>